import React from 'react';
import { Navigate, Params } from 'react-router-dom';

export interface VirtualRouteProps {
    onRoute: (pathParams: Params<string> | undefined, searchParams: URLSearchParams) => void;
}

const VirtualRoute: React.FC<VirtualRouteProps> = () => {
    // TODO - handle browser link opened.
    return <Navigate to="/" />;
};

const hookProviderStore: {
    freezed: boolean;
    registeredHooks: HookDesc<unknown>[];
} = {
    freezed: false,
    registeredHooks: [],
};

interface HookDesc<T> {
    useHookInitFn: () => T;
    useHookReturn?: T;
    get: () => T | undefined;
}

function requireHook<T>(useHookInitFn: () => T): HookDesc<T> {
    const hookDesc: HookDesc<T> = {
        useHookInitFn,
        get: () => {
            return hookDesc.useHookReturn!;
        },
    };

    let existingHook: HookDesc<unknown> | null = null;
    hookProviderStore.registeredHooks.forEach((hookDesc) => {
        if (hookDesc.useHookInitFn.toString() === useHookInitFn.toString()) {
            existingHook = hookDesc;
        }
    });

    if (existingHook) {
        return existingHook as HookDesc<T>;
    }

    if (hookProviderStore.freezed) {
        throw new Error('requireHook only can be invoke inner VirtualRoutes definition scope.');
    }

    hookProviderStore.registeredHooks.push(hookDesc);
    return hookDesc;
}

export interface VirtualRouteHookSupportProps {
    outlet: React.ComponentType;
}

const VirtualRouteHookProvider: React.FC<VirtualRouteHookSupportProps> = ({ outlet: Outlet }) => {
    hookProviderStore.freezed = true;

    hookProviderStore.registeredHooks.forEach((hookDesc) => {
        hookDesc.useHookReturn = hookDesc.useHookInitFn();
    });

    return <Outlet />;
};

export { VirtualRoute, requireHook, VirtualRouteHookProvider };
